import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthContextProvider } from './context/AuthContext';
import { PaymentsContextProvider } from './context/PaymentContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<AuthContextProvider>
			<PaymentsContextProvider>
				<App />
			</PaymentsContextProvider>
		</AuthContextProvider>
	</React.StrictMode>
);
